import type {ContributorsInfo} from '@github-ui/repos-types'
import React from 'react'

export interface ContributorsData {
  contributors?: ContributorsInfo
  loading?: boolean
  error?: Error | null
}

const ContributorsContext = React.createContext<ContributorsData>({
  contributors: undefined,
  error: undefined,
  loading: false,
})

export function ContributorsProvider({
  children,
  contributors,
  error,
  loading,
}: React.PropsWithChildren<ContributorsData>) {
  const value = React.useMemo(() => ({contributors, error, loading}), [contributors, error, loading])
  return <ContributorsContext value={value}>{children}</ContributorsContext>
}

export function useContributorsContext() {
  return React.use(ContributorsContext)
}
